import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Breadcrumbs } from './Breadcrumb';
import Headline3 from './Typography/Heading/Headline3';
import Body1 from './Typography/Body/Body1';
import breakpoints from './Theme/breakpoints';

const Container = styled.div`
  padding: 0 1rem;
  max-width: 1100px;
  margin: auto;

  @media (min-width: ${breakpoints.md}px) {
    padding: 0 4rem;
  }
`;

const SectionHeading = styled(Headline3)`
  && {
    text-align: center;
    margin: 2rem 1rem 1rem;
  }
`;

const SectionDescription = styled(Body1)`
  && {
    text-align: center;
  }
`;

const ProseSection = styled.section`
  margin: 4rem 0 2rem;
  text-align: center;

  h2 { display: none; }
  p { display: inline; }
  p + p::before { content: ' '; }
  br { display: none; }
`;

interface PremiumEmployerLayoutProperties {
  breadcrumbs: ReactNode[];
  packageTiers: ReactNode;
  sectionsTitle: string;
  sectionsDescription: string;
  featureCards: ReactNode;
  featuredEmployersTitle: string;
  featuredEmployers: ReactNode;
  textWithImageComponents: ReactNode;
  contactContent?: ReactNode;
}

const PremiumEmployerLayout = ({
  breadcrumbs,
  packageTiers,
  sectionsTitle,
  sectionsDescription,
  featureCards,
  featuredEmployersTitle,
  featuredEmployers,
  textWithImageComponents,
  contactContent,
}: PremiumEmployerLayoutProperties) => (
  <Container>
    <Breadcrumbs crumbs={breadcrumbs} />
    {packageTiers}
    <SectionHeading tag="h2">{sectionsTitle}</SectionHeading>
    <SectionDescription>{sectionsDescription}</SectionDescription>
    {featureCards}
    <SectionHeading tag="h2">{featuredEmployersTitle}</SectionHeading>
    {featuredEmployers}
    {textWithImageComponents}
    {contactContent && (
      <ProseSection>
        <Body1 tag="div">{contactContent}</Body1>
      </ProseSection>
    )}
  </Container>
);

export default PremiumEmployerLayout;
